const defaultState = {
  orders: [],
  ordersResponse: undefined,
  fileContent1: undefined,
  fileContent2: undefined,
  responseMessage: undefined,
  selectedOrder: undefined,
  selectedOrderList: {},
  selectedOrderId: undefined,
  productsMessage : undefined,
  products: [],
  singleProduct: undefined,
  productModal: undefined,
  productForCart: [],
};

export default (state = defaultState, action) => {
  switch(action.type){
    case 'SET_CREATE_PRODUCT_IMAGES':
      return {
        ...state,
        fileContent1: action.fileContent1,
      }
    case 'SET_CALLBACK_MESSAGE':
      return {
        ...state,
        responseMessage: action.responseMessage
      }
    case 'SET_PRODUCTS_MESSAGE':
      return {
        ...state,
        productsMessage: action.productsMessage
      }
    case 'SET_PRODUCTS':
      return {
        ...state,
        products: action.products
      }
    case 'SET_SINGLE_PRODUCT':
      return {
        ...state,
        singleProduct: action.singleProduct
      }
    case 'SET_PRODUCT_MODAL_STATE':
      return {
        ...state,
        productModal: action.productModal
      }
    case 'SET_SINGLE_PRODUCT_FOR_CART':
      return {
        ...state,
        productForCart: action.productForCart
      }
    default:
      return state;
  };
};
